import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Opportunities">
                            <h2>Monumental Growth Opportunities Through Digital Marketplace Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol has helped businesses scale from brick-and-mortar stores to high-revenue online
                            entities, including eCommerce, SaaS programs, and full-service digital,l marketplaces in the
                            last five years. </p>
                        <p>With our marketplace development consultancy and solutions, you can automate the order
                            management and delivery cycle. Moreover, you can capitalize on the ready market share and
                            acquire an existing customer base. It will Improve supply chain efficiency, reach a wider
                            audience with low acquisition costs and collect and process insightful data.</p>
                        <p>What else can you achieve with Tekrevol’s custom-built digital marketplace services?</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;